const PATHS = {
  'GET-ALL': 'products/all-no-pag'
}

export default PATHS
